import { _ as _defineProperty } from './defineProperty-377d5a7f.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-a0edb288.js';
import 'react';
import dompurify from 'isomorphic-dompurify';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["tag", "html"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CONFIG = {
  ADD_ATTR: ['target']
};
// we need to be able to specify target, but it needs to be safe https://web.dev/external-anchors-use-rel-noopener/
dompurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('rel', 'noopener');
  }
});
function SanitizeHtml(_ref) {
  var Component = _ref.tag,
    html = _ref.html,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Component, _objectSpread({
    dangerouslySetInnerHTML: {
      __html: dompurify.sanitize(html, CONFIG)
    }
  }, props));
}

export { SanitizeHtml as S };
//# sourceMappingURL=SanitizeHtml-1e397388.js.map
